import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AvailCriteria } from 'app/types/project-config';
import { AttributeComparisonComponent } from './../../attribute-comparison/attribute-comparison.component';
import { AttributeConditionsDialogConfig } from './attribute-conditions-dialog.component';
import { Injectable, EventEmitter, ViewChild } from '@angular/core';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';

@Injectable({
  providedIn: 'root'
})
export class AttributeConditionsDialogService {

   public requests = new EventEmitter<AttributeConditionsDialogConfig>();
  constructor() { }
  Show(config:AttributeConditionsDialogConfig): void {
    this.requests.emit(config);
  }

}
